import {LobbyImage} from '@colonist/types'
import {TranslationObject} from '@colonist/i18n'
import {createDivIn, createImgIn, createLinkIn, createParagraphIn} from '../../../../shared/scripts/ui_utils/DomUtils'

export class UIMFullscreenHeader {
    container: HTMLDivElement
    backButton: HTMLLinkElement
    title: HTMLParagraphElement

    constructor(container: HTMLDivElement, title: TranslationObject) {
        this.container = createDivIn(container, 'fullscreen-header')
        this.backButton = createLinkIn(this.container, '', {key: 'strings:colonistCommon.utils.emptyString'}, 'fullscreen-header-back-link')
        this.backButton.removeAttribute('href')
        createImgIn(this.backButton, LobbyImage.LeftArrow)
        this.title = createParagraphIn(this.container, title, 'fullscreen-header-title')
    }
}
